export const useStyles = {
  dialog: {
    '.MuiPaper-root': {
      background: 'transparent'
    }
  },

  dialogContentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: "15px",
    paddingTop: '10px'
  },

  formControl: {
    paddingTop: '10px',
    ".MuiInputBase-root": {
      fontSize: "12px",
      width: "300px",
      backgroundColor: "#F9FBFF",
      borderRadius: "4px",
      border: '1px solid #16604B!important',
      boxSizing: 'border-box',
      "&:hover": {
        backgroundColor: "#F9FBFF"
      },
    },
    '.MuiFormLabel-root': {
      color: `#16604B!important`
    },
    '.MuiFormLabel-root.Mui-focused': {
      color: `#16604B!important`
    },
    ".MuiSelect-select": {
      fontWeight: 600,
      color: '#16604B',
    },
    ".MuiTypography-root": {
      fontSize: "12px",
      color: '#16604B',
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    ".MuiInputBase-root:before": {
      border: "none!important",
    },
    ".MuiInputBase-root:after": {
      border: "none!important",
    },
    "& .MuiSelect-select": {
      paddingTop: "7px",
      paddingBottom: "7px",
      borderRadius: "8px",
      lineHeight: "18px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      borderBottom: "none",
    }
  },

  select: {
    '.MuiSelect-filled': {
      paddingRight: '0',
    },
  },

  menuItem: {
    fontSize: "14px",
  },

  linkButton: {
    padding: '6px 28px',
    fontSize: '12px',
    background: '#1B3665',
    width: 'fit-content',
    margin: '15px auto 10px auto',
    textTransform: 'initial'
  },

  details: {
    padding: "8px 15px",
    borderRadius: '4px',
    backgroundColor: '#fff!important',
    boxShadow: 'none'
  },

  detailsHeading: {
    fontSize: "14px",
    color: '#2D3748',
    fontWeight: 700,
    marginBottom: '9px'
  },

  detailsText: {
    fontSize: "12px",
    color: '#2D3748',
    opacity: 0.6,
    marginBottom: '5px'
  },
};
